import {useQueryClient} from '@tanstack/react-query'
import React, {useMemo, useRef} from 'react'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {useAdditionalInformationCRUD} from '../../additional-information/query-keys/AdditionalInformationQueryManager'
import {useAuth} from '../../authentication/AuthProvider'
import {genericLogQueryType} from '../generic-log/GenericLogConstansts'
import {additionalInformationList} from './StyledDetailInformationConstants'
import StyledDetailInformationSection from './StyledDetailInformationSection'
import {usePatientContext} from './StyleDetailInformationWrapper'

const StyledAdditionalInformationSection = () => {
    const {user} = useAuth()

    const ref = useRef()

    const {currentViewedUser} = usePatientContext()

    const {mutateAsync: createOrUpdateAdditionalInfo} =
        useAdditionalInformationCRUD(QueryCRUDTypes.update, user?.id)

    const queryClient = useQueryClient()

    const {patientKeys} = QueryKeyManager(QueryKeyTypes.patient, user?.id)

    const patientQueryKeys = useMemo(() => {
        return patientKeys.detail({id: currentViewedUser?.id})
    }, [patientKeys, currentViewedUser?.id])

    const handleOnSubmit = async data => {
        let toPostData = {
            ...data,
            id: data?.id || null,
            userId: currentViewedUser?.id,
        }

        const additionalInfoData = await createOrUpdateAdditionalInfo(
            toPostData,
        )

        if (additionalInfoData?.id) {
            queryClient.invalidateQueries(patientQueryKeys)
            ref.current.onSuccess()

            const {genericLogKeys} = QueryKeyManager(
                QueryKeyTypes.genericLog,
                user?.id,
            )
            queryClient.invalidateQueries(
                genericLogKeys.pattern({
                    type: genericLogQueryType.userLog,
                }),
            )
        }
    }

    return (
        <React.Fragment>
            <div className="">
                <StyledDetailInformationSection
                    ref={ref}
                    data={currentViewedUser}
                    dataList={additionalInformationList}
                    onSubmit={handleOnSubmit}
                />
            </div>
        </React.Fragment>
    )
}
export default StyledAdditionalInformationSection
